<template>
    <div class="box-offset">
        <ValidationObserver ref="form">
            <div class="box-ttl">
                Add New Sites/Clients
            </div>
            <div class="form mt-3">
                <div class="row">
                    <ValidationProvider v-slot="{errors}" rules="required" name="Name" class="col-md-12">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Site Name</label>
                            <input type="text" v-model="client.name" class="form-control">
                            <FormError :error="errors[0]" name="Name"></FormError>
                        </div>
                    </ValidationProvider>

                    <div class="col-md-6">
                        <label for="" class="form-label">Address</label>
                        <VueGoogleAutocomplete
                            id="map1"
                            :country="`us`"
                            classname="form-control"
                            placeholder="Start typing"
                            :options="autocompleteOptions"
                            v-on:placechanged="getAddressData"

                        ></VueGoogleAutocomplete>
                    </div>

                    <ValidationProvider v-slot="{errors}" rules="required" name="City" class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">City</label>
                            <input type="text" v-model="client.city" class="form-control">
                            <FormError :error="errors[0]" name="City"></FormError>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider v-slot="{errors}" rules="required|numeric" name="Zip" class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Zip Code</label>
                            <input type="text" v-model="client.zip_code" class="form-control">
                            <FormError :error="errors[0]" name="Zip"></FormError>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider v-slot="{errors}" rules="required" name="State" class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">State</label>
                            <input type="text" v-model="client.state" class="form-control">
                            <FormError :error="errors[0]" name="State"></FormError>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider class="col-md-6" v-slot="{errors}" rules="required" name="Status">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Status</label>
                            <select id="" v-model="client.status" class="custom-select">
                                <option value="active" selected>Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                            <FormError :error="errors[0]" name="Status"></FormError>
                        </div>
                    </ValidationProvider>

                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Position</label>
                            <div class="form-group form-group-1 mb-0 ">
                                <VueMultiSelect
                                    allow-empty="required"
                                    multiple="multiple"
                                    :options="positionsOptions"
                                    v-model="selectedPositions"
                                    @input="fillIdArray()"
                                ></VueMultiSelect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="btns-wrap">
                            <a href="javascript:void(0)" @click="window.history.back()"
                               class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                            <a href="javascript:void(0)" @click="saveClient"
                               class="btn btn--secondary w-100 w-sm-auto">Save</a>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import SiteClientsService from "./services/SiteClientsService";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import VueMultiSelect from "../../../../../resources/js/plugins/VueMultiSelect.vue";

export default {
    name: "NewSite",
    components: {VueMultiSelect, VueGoogleAutocomplete},
    data() {
        return {
            positionsList: [],
            positionsOptions: [],
            selectedPositions: [],
            states: [],
            client: {
                address: null,
                city: null,
                name: null,
                positions: [],
                status: 'inactive',
                state: null,
                zip_code: null,
            },
            autocompleteOptions: {
                types: ['(regions)'],
                componentRestrictions: {country: 'us'}
            }
        }
    },

    methods: {
        getAddressData(place) {
            let {locality, postal_code, administrative_area_level_1, route, street_number} = place
            this.client.zip_code = postal_code
            this.client.city = locality
            if (route && street_number) {
                this.client.address = `${street_number} ${route}`;
            } else {
                this.client.address =  street_number || route|| '';
            }
            this.findStateFullName(administrative_area_level_1)
        },
        async getListOfPositions() {
            try {
                const {data: positions} = await CommonService.getListOfPositions()
                this.positionsList = positions
                this.positionsOptions = this.positionsList.map(pos => (pos.title));
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        async getListOfStates() {
            try {
                const {data: states} = await CommonService.getListOfStates()
                this.states = states
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        fillIdArray() {
            this.client.positions = []
            this.selectedPositions.forEach(selPos => {
                const foundPosition = this.positionsList.find(pos => pos.title === selPos);
                if (foundPosition) {
                    this.client.positions.push(foundPosition.id);
                }
            });
        },
        findStateFullName(stateN) {
            const foundState = this.states.find(state => state.abbreviation === stateN)
            this.client.state = foundState.name
        },
        async saveClient() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();
            if (!valid) {
                this.$showValidationErrorMessage()
                return;
            }
            try {
                await SiteClientsService.saveNewSite(this.client);
                this.$showSuccessMessage('New Client was added!');
                setTimeout(() => {
                    window.location.href = '/master-admin/sites-clients'
                }, 1000)
                this.$showSuccessMessage();
            } catch (e) {
                console.error(e)
                this.$showErrorMessage();
            }
        }
    },
    mounted() {
        this.getListOfStates();
        this.getListOfPositions();
    }
}

</script>

<style scoped>

</style>
